export default {
    alignToolbar: {
        algnLeft: '左对齐',
        algnCenter: '水平居中',
        algnRight: '右对齐',
        alginTop: '顶部对齐',
        alginVertical: '垂直居中',
        alginBottom: '底部对齐',
        vertical: '垂直分布',
        horizontal: '水平分布',
        relativeCanvas: '相对画布',
        betweenEl: '元素之间',
        typesetting: '排版',
    },
    baseLayer: {
        imageLayerAiItem: {
            aIExpendImage: 'AI扩图',
            aIModifyImage: '局部重绘',
            aiTextMaterial: 'AI花字',
        },
        shortcutOperate: {
            unGroup: '取消组合',
            unSupportGroup: '付费素材不支持解组使用',
            group: '组合',
            unlockGroupRemove: '移动素材',
            copy: '创建副本',
            copyStyle: '复制样式',
            delete: '删除',
            more: '更多',
            editText: '编辑文字',
            editChartData: '编辑数据',
            copyEffect: '复制效果',
            cursorTip: '按住SHIFT可连续',
        },
        baseOperate: {
            title: '解锁图层',
        },
        batchTemplate: {
            cover: '填充展示',
            full: '完整展示',
        },
        replaceImageOperate: {
            btnText: '替换',
        },
    },
    brushLayer: {
        customBrush: '自定义画笔',
        Behavior: {
            line: '直线笔',
            curve: '曲线笔',
            shape: '形状',
        },
        tips: {
            moveToCanvas: '移动到画布中绘制',
        },
    },
    buyVipLayer: {
        vipText: '开通会员去水印',
    },
    buyVipModal: {
        text: '会员中心',
    },
    comToolBar: {
        copyBtn: {
            copyText: '复制图层',
        },
        deleteBtn: {
            delText: '删除图层',
        },
        flipBtn: {
            verticalRotate: '垂直翻转',
            horizontalRotate: '水平翻转',
            layerRotate: '图层翻转',
        },
        lockBtn: {
            lock: '锁定图层',
            unLock: '解锁图层',
        },
        sortBtn: {
            index: '图层顺序',
            bottom: '图层置底',
            top: '图层置顶',
            order: '图层排序',
        },
        textBrushBtn: {
            copyStyle: '复制样式',
        },
    },
    contextMenuLayer: {
        menuConfig: {
            alignLeft: '左对齐',
            alignRight: '右对齐',
            alignHorizontal: '水平居中',
            alignVertical: '垂直居中',
            alignTop: '顶部对齐',
            alignBottom: '底部对齐',
            horizontalDistribution: '水平分布',
            verticalDistribution: '垂直分布',
            makeGroup: '成组',
            brokeGroup: '解组',
            layerSort: '图层排序',
            sortTop: '置顶',
            sortBottom: '置底',
            sortUp: '上移一层',
            sortDown: '下移一层',
            overlap: '选中重叠的图层',
            lock: '锁定图层',
            alignCanvas: '与画布对齐',
            alignElement: '元素之间对齐',
            delete: '删除',
            addMySpace: '添加到我的空间',
            upload: '上传',
            backgroundSet: '设为背景图',
            backgroundSplit: '分离背景图',
            copy: '复制',
            cut: '剪切',
            paste: '粘贴',
            createCopy: '创建副本',
        },
        menu: {
            lock: '锁定图层',
            unLock: '解锁图层',
            successText: '背景已分离成图片',
        },
        upload: {
            addImage: '添加图片...',
        },
    },
    corpImage: {
        tip: '已达最大值',
        scale: '缩放',
        adjustImage: '适配图片',
        reset: '重置',
    },
    displaceMent: {
        left: '左移',
        right: '右移',
        top: '上移',
        bottom: '下移',
        deg: '角度',
        minValue: '已达最小值',
        width: '宽度',
        height: '高度',
    },
    downLoadTip: {
        tip: '作品已下载到这里',
    },
    filterList: {
        errorText: '网络错误：请重试或检查您的网络状态',
        operate: {
            cancel: '取消',
            applay: '应用',
            strength: '强度',
            apply: '应用',
        },
        utils: {
            noFilter: '无滤镜',
            filter: '常用滤镜',
        },
        filterCategory: {
            more: '查看更多',
        },
    },
    globalMask: {
        loading: '加载中',
    },
    groupLayer: {
        title: '解锁组内移动',
    },
    hooks: {
        useNetWork: {
            onLine: '网络已重新连接',
            unOnLine: '网络错误：请重试或检查您的网络状态',
        },
    },
    imageEffectPanel: {
        title: '图片特效',
        effect: '效果',
        constants: {
            normal: '常规',
            outSolidLine: '外扩实线',
            outDashedLine: '外扩虚线',
            tornPaper: '撕纸',
        },
        imageBlur: {
            title1: '经典模糊',
            title2: '玻璃模糊',
            classic: '经典',
            glass: '玻璃',
            strength: '强度',
            cancel: '取消',
            apply: '应用',
            cancelBlur: '无',
        },
        imageGlowItem: {
            title1: '外发光',
            title2: '颜色',
            title3: '范围',
            title4: '透明度',
            outGlow: '外发光',
            color: '颜色',
            scope: '范围',
            opacity: '透明度',
        },
        imageShadowItem: {
            title1: '投影',
            title2: '颜色',
            title3: '模糊',
            title4: '透明度',
            title5: '距离',
            shadow: '投影',
            color: '颜色',
            blur: '模糊',
            opacity: '透明度',
            dis: '距离',
            range: '范围',
            direction: '方向',
            rotate: '旋转',
            brightness: '亮度',
            wave: '波纹',
            waveNum: '波纹数量',
            yOffset: 'Y轴偏移',
            xOffset: 'X轴偏移',
            length: '长度',
        },
        imageStrokeItem: {
            title1: '描边',
            title2: '颜色',
            title3: '范围',
            title4: '透明度',
            title5: '样式',
            stroke: '描边',
            color: '颜色',
            scope: '范围',
            opacity: '透明度',
            style: '样式',
        },
        imageEffectMenu: {
            imageEffect: '图片特效',
        },
        subTitle: {
            baseTitle: '基础特效',
            blurTitle: '模糊特效',
        },
        borderRadiusItem: {
            title: '圆角',
            modalTitle: '圆角设置',
        },
        imageShadowType: {
            baseProjection: '基础投影',
            lightProjection: '光照投影',
            reflection: '倒影',
            waterSurface: '水面波纹',
        },
    },
    imageLayer: {
        useImageExpandHelper: {
            replaceImage: '请先替换图片',
            errorText: '切换失败，请重试',
        },
        renderDropImage: {
            dropImage: '拖入图片',
            freedImage: '释放图片',
        },
    },
    appName: '美图设计室',
    loginNow: '立即登录',
    imageMatting: {
        confirmText: '是否应用抠图结果',
        remainPage: '剩余张数',
        consumeAfterApply: '应用后消耗',
        cutoutRemainPage: '抠图剩余张数',
        remainPageConfirm: '确认应用后才消耗，若替换图片后抠图需再次消耗',
        mattingOptimize: '抠图优化',
        cancel: '取消',
        apply: '应用',
        consumeOne: '消耗${0}张',
        recharge: '获取张数',
        applyTips: 'This action will be applied to your image',
    },
    imageUpload: {
        btnText: '上传文件',
        heicErrorText: 'HEIC图片解析失败，建议您转换为其他图片格式上传',
        beforeUploadError: '每次最多允许上传${0}张',
        supportImageSize: '仅支持${0}M以内的图片',
        supportImageType: '暂时只支持JPG/JPEG/PNG/SVG/HEIC/GIF/WEBP格式图片',
        sizeLimit: '最大支持 ${0} x ${1} 的图片上传',
    },
    listCard: {
        rightText: '全部',
    },
    mainLayer: {
        brushSize: '画笔大小',
        penType: {
            tab: {
                legacy: '手动消除',
                aiLeGacy: 'AI 消除',
            },
            config: {
                daub: '涂抹',
                rect: '框选',
                path: '圈选',
                add: '增加',
                remove: '去除',
                clear: '清空',
                text: '文字',
                watermark: '水印',
                unwantedPeople: '路人',
                glass: '眼镜',
                quickStartDesc: '启用类别来自动检测并删除指定对象。',
                quickStart: '快速开始',
                advanced: '高级',
                advancedDesc: '手动选择区域消除',
                glare: '反光',
            },
        },
        enhance: {
            config: {
                smartLightAlpha: '智能补光',
                light: '亮度',
                contrast: '对比度',
                saturation: '饱和度',
                structure: '清晰度',
                sharpen: '锐化',
                temperature: '色温',
                tinge: '色调',
                hslHue: '色相',
                hslSaturation: '饱和度',
                hslLight: '明度',
                highlight: '高光',
                shadow: '暗部',
                fade: '褪色',
                vignette: '暗角',
                particle: '颗粒',
                dispersion: '色散',
                posterizeLight: '饱和度',
            },
        },
        posterSize: {
            light: '高光',
            shadow: '阴影',
        },
        intelligent: {
            protectArea: {
                pen: '画笔',
                eraser: '橡皮擦',
                messageInfo: '请先退出取色笔~',
                title: '请在右侧图中涂抹保护区域',
                brushSize: '画笔大小',
                clearProtectArea: '清空保护区域',
                startProtectArea: '开启保护区域',
            },
            selectColor: {
                messageInfo1: '当前功能仅对原图生效，已自动隐藏无法操作的内容',
                messageInfo2: '请先清空保护区域后使用取色笔~',
                selectColor: '请选择原图上的颜色',
            },
            reset: '重置',
            sourceColor: '源颜色',
            sourceColorDesc: '选择图片中的一种颜色',
            colorTolerance: '颜色容差',
            targetColor: '目标颜色',
            targetColorDesc: '需要替换成的颜色',
            chooseColor: '选择颜色',
            erase: '擦除',
            eraseDesc: '擦除或涂抹目标颜色区域',
            brush: '画笔',
            eraser: '橡皮擦',
            clear: '清空',
            recommendedEffect: '推荐效果',
            resetEffect: '重置效果',
            manualColor: '手动调色',
            hue: '色相',
            hueDesc: '色相指颜色，如蓝色、红色等',
            saturation: '饱和度',
            saturationDesc: '饱和度指色彩的纯度，饱和度越高色彩越浓',
            brightness: '明度',
            brightnessDesc: '明度指色彩明亮程度，明度越高色彩越亮',
            messageInfo: '请先退出取色笔~',
            messageInfo1: '当前功能仅对原图生效，已自动隐藏无法操作的内容',
            messageInfo2: '请先清空保护区域后使用取色笔~',
        },
        models: {
            config: {
                all: '整图',
                pickColor: '取色',
            },
        },
        operate: {
            colorPickPen: '取色个数已到达上限~',
            messageInfo: '当前功能仅对原图生效，已自动隐藏无法操作的内容',
            handleMessage: '处理中...',
            errorMessage: '清除失败，请重试',
            startErase: '开始消除',
            autoRecognizing: '自动识别中',
            emptyAreaTips: '请选择需要消除的区域',
            textEmptyAreaTips: '未识别到文本，请尝试手动选择需要消除的部分。',
            watermarkEmptyAreaTips: '未识别到水印，请尝试手动选择需要消除的区域。',
            glassesEmptyAreaTips: '未识别到眼镜，请尝试手动选择需要消除的区域。',
            passerbyEmptyAreaTips: '未识别到路人，请尝试手动选择需要消除的对象。',
            auditFailedTips: '图片涉及敏感信息，请换张图试试～',
            inputAuditFailedTips: '图片涉及敏感信息，请换张图试试～',
        },
        selectionTools: '选区工具',
        autoIdentification: '自动识别',
    },
    navigatorLayer: {
        adaptScale: '适应屏幕',
        realSize: '实际大小',
        open: '展开导航器',
        hidden: '收起导航器',
        minCanvas: '已缩小至最小画布',
        maxCanvas: '已放大至最大画布',
        shrink: '缩小',
        enlarge: '放大',
        keyboardKeyMap: '快捷键',
        contactMessage: '在线咨询',
        feedBack: '意见反馈',
        referenceLine: '参考线',
        verticalReferenceLine: '竖向参考线',
        horizontalReferenceLine: '横向参考线',
        clearReferenceLine: '清空参考线',
        contrast: '对比',
        pressToView: '长按查看原图',
        canvasSize: '画布尺寸',
        showRulerBar: '显示标尺',
        hideRulerBar: '隐藏标尺',
        referenceLinesAndRulers: '参考线与标尺',
        releaseToDelete: '放开删除',
    },
    psdParse: {
        delLayer: '删除隐藏图层',
        parseLayer: '解析图层数据',
        waitingText: '调整文本图层宽高， 耗时可能较长请耐心等待',
        replaceFont: '文本图层${0}：${1}字体被替换',
        computedSize: '计算图层组宽高',
        genPreview: '生成图预览图',
        mixLayer: '合成图层组',
        parseEnd: '解析结束',
        readPsdData: '读取psd数据',
        emptyPsdData: '读取psd数据为空文件',
        limitCount: '仅支持画板拓展个数为20个，请减少画板数量重新上传',
        retryUpload1: '不允许存在画板嵌套，请重新上传。',
        retryUpload2: '仅支持画板最长边小于 2448px，请重新上传',
        bgLayerError: '背景图层不规范',
        parseTextLayer: '解析文本图层：${0}',
        emptyBgSize: '背景图层宽高不能为0',
        minBgSize: '背景图层宽高不能都小于10',
        maxBgSize: '背景图层宽高不得大于当前画布尺寸2倍及以上',
        bgLayer: '背景图层',
        noChildLayer: '图层${groupLayer.title}：没有子图层,是个无效图层',
        parseImageLayer: '解析图片图层：${0}',
        qrCode: '二维码',
        maxImageLayerMultiple: '图片图层${0}：图层宽高大于当前画布尺寸2倍',
        minImageLayerSizeOf0: '图片图层${0}：宽高不能小于0',
        minImageLayerSizeOf10: '图片图层${0}：宽高不能都小于10px',
        emptyUrl: '图片图层${0}： 解析不到图片，url是空的',
        minTextLayerSize: '文本图层${0}：字体大小不能大于模板的宽度',
        minTextLayerSizeOf0: '文本图层${0}：宽高不能小于0',
        minTextLayerSizeOf10: '文本图层${0}：宽高不能都小于10px',
        minTextLayerSpacingOf0: '文本图层${0}：行间距小于0',
        textLayerSpacingMinFont: '文本图层${0}：行间距小于字体大小',
        minTextLayerFontOf12: '文本图层${0}：字体大小小于12',
        emptyTextLayer: '文本图层${0}：文本为空，可能是个空图层',
        customImageName: '自定义图片',
        parseVectorLayer: '解析矢量图层：${0}',
        maxVectorMultiple: '矢量图层${0}：图层宽高大于当前画布尺寸2倍',
        minVectorSize: '矢量图层${0}：宽高不能小于0',
        replaceFonts: '字体已被替换为${0}',
        emptyBg: '没有背景图层或者背景图层不在第一个',
        layerWidthOf0: '图层宽度为0',
        layerHeightOf0: '图层高度为0',
        minLayerWidthOf10: '图层宽度小于10是否有问题',
        minLayerHeightOf10: '图层高度小于10是否有问题',
        emptyUrlText: '图片url不存在',
        fontSpaceLimit0: '字间距小于0',
        spaceMinFont: '行间距小于字体大小',
        fontLimit12: '字体大小小于12px',
        emptyText: '文本字段为空，可能是个空图层',
        emptyLayer: '图层组没有子图层，可能是个无效图层组',
        maxMaskLimitCanvas: '蒙版${0}：不能大于当前画布1.5倍',
    },
    request: {
        errorText: '请求出错，请稍后再试',
    },
    stageManager: {
        canvasLimitScope: '画布尺寸需在限制范围内',
        height: '高',
        width: '宽',
        page: '页面',
        prePage: '上一页',
        moveUpPage: '上移页面',
        nextPage: '下一页',
        moveDownPage: '下移页面',
        addPage: '添加页面',
        copyPage: '复制页面',
        delPage: '删除页面',
        dragHeight: '拖动调整页面高度',
        maxStageLimit: '仅支持添加画板上限为${0}个',
    },
    svgLayer: {
        edgsConfig: {
            triangle: '3（三角形）',
            diamond: '4（菱形）',
            pentagon: '5（五边形）',
        },
        shapeConfig: {
            line: '直线',
            arrow: '箭头',
            curve: '曲线',
            circle: '圆形',
            square: '矩形',
            polygon: '多边形',
            heart: '心形',
            star: '星形',
        },
        dasharray: '画笔类型',
        edgs: '边数',
        fillColor: '填充颜色',
        brushSrength: '画笔强度',
        radius: '圆角',
        reset: '重置',
        strokeColor: '画笔颜色',
        brushWidth: '画笔大小',
    },
    tableLayer: {
        mergeCell: '合并单元格',
        cancelMergeCell: '拆分单元格',
        column: '列',
        row: '行',
        behavior: {
            limitWidth: '单元格不能再窄啦～',
            limitHeight: '单元格不能再矮啦～',
        },
        hooks: {
            supportText: '仅支持${0}行*${1}列的文件，超出部分自动舍弃',
            maxSupportText: '最多支持${0}行*${1}列哦',
            upAdd: '在上面添加',
            downAdd: '在下面添加',
            delSelectRow: '删除所选行',
            leftAdd: '在左侧添加',
            rightAdd: '在右侧添加',
            delSelectColumn: '删除所选列',
            clear: '清除内容',
            parseFailed: '表格解析失败',
        },
        panel: {
            count: '行列数',
            color: '单元格颜色',
            borderStyle: '边框样式',
            lineStyle: '线条样式',
            autoWrap: '自动换行',
            selectStyle: '请选择表格样式',
        },
        delete: '删除',
        columnShort: '列',
        rowShort: '行',
    },
    textAction: {
        fontSpacing: '字间距',
        rowSpacing: '行间距',
        opacity: '透明度',
        spacing: '间距',
    },
    textAlign: {
        alignLeft: '左对齐',
        alignRight: '右对齐',
        alignTop: '上对齐',
        alignBottom: '下对齐',
        alignCenter: '居中对齐',
        alignBetween: '两端对齐',
        textPosition: '文字方向',
        textSpacing: '字间距',
        rowSpacing: '行间距',
        listFormat: '列表格式',
    },
    textAlignMent: {
        align: '对齐',
        alignLeft: '左对齐',
        alignRight: '右对齐',
        alignTop: '上对齐',
        alignBottom: '下对齐',
        alignCenter: '居中对齐',
        alignBetween: '两端对齐',
        alginVertical: '竖直居中',
    },
    textAttr: {
        style: '样式',
        strong: '加粗',
        italic: '斜体',
        underLine: '下划线',
        lineThrough: '删除线',
        textVertical: '竖排文字',
        listFormat: '列表格式',
    },
    utils: {
        uploadNetworkErr: '您的网络发生异常，图片上传失败',
        networkErr: '您的网络发生异常，无法连接服务器',
    },
    userInfo: {
        vipOutDate: 'VIP到期:',
        notVipInfo: '您还未开通会员',
        vipOutDateInfo: '您的会员已过期',
        loginAndCheckState: '登录查看会员状态',
        buyVipAndEnjoyVip: '续费会员享专属素材&功能',
    },
    thresholdListPanel: {
        vipContentInfo: '作品使用了${0}个会员内容',
        needPayContentInfo: '当前有${0}个付费素材',
    },
    textStyleSelector: {
        clearStyle: '清除样式',
        specialEffect: '特效',
    },
    textStyleAdd: {
        color: '颜色',
        range: '范围',
        blur: '模糊',
        distance: '距离',
        opacity: '透明度',
        fillOrGradient: '填充/渐变',
        stroke: '描边',
        shadow: '投影',
        glow: '外发光',
        background: '背景',
    },
    textListStyle: {
        color: '颜色',
        size: '大小',
    },
    textLayer: {
        defaultText: '双击编辑文字',
        unorderList: '无序列表',
        orderList: '有序列表',
        strength: '强度',
        size: '大小',
        startAngel: '起始角度',
        eccentricity: '离心率',
        reversePath: '反转路径',
        widthHeightRatio: '长宽比',
        startPosition: '起始位置',
        widthLength: '长度',
        sideLength: '边数',
        roundRadius: '圆角',
        relativeHeight: '相对高度',
    },
    textFontSizeAndTextColor: {
        size: '字号',
    },
    textFontSize: {
        limit: '请输入字号范围在${0}~${1}之间的整数',
    },
    textFontFamily: {
        empty: '暂无内容',
        changeSearchWord: '换个搜索词再试试',
        fontFamily: '字体',
        searchFont: '搜索字体',
        buyVipEnjoyFontFamily: '开通会员，可免费商用该字体',
        currentFontFamily: '当前模版使用的字体',
    },
    layers: {
        text: '文字',
        image: '图片',
        vector: '图形',
        background: '背景',
        group: '组合',
        qrCode: '二维码',
        table: '表格',
        brush: '画笔',
        watermark: '水印',
        markup: '标注',
        chart: '图表',
    },
    keyboardKeyMap: {
        title: '键盘快捷键',
        function: '功能',
        windows: 'Windows系统',
        mac: 'Mac系统',
        undo: '撤销',
        redo: '重做',
        delete: '删除',
        cut: '剪切',
        copy: '复制',
        paste: '粘贴',
        selectAll: '全选',
        multipleSelect: '多选',
        multipleSelectDescWin: '按下 Ctrl/Alt，鼠标点击图层',
        multipleSelectDescMac: '按下 ⌘/⌥，鼠标点击图层',
        makeGroup: '成组',
        brokeGroup: '解组',
        lock: '解锁图层/锁定图层',
        saveRecord: '保存记录',
        save: '保存/下载图片',
        move: '移动 1 px',
        ArrowKey: '方向键',
        scale: '放大/缩小',
        sortTop: '置顶',
        sortBottom: '置底',
        sortUp: '上移一层',
        sortDown: '下移一层',
        exitFullScreen: '退出全屏',
        esc: 'ESC',
        toggleReferenceLine: '显示/隐藏参考线',
        fixedPaste: '固定位置粘贴',
        createCopy: '创建副本',
        createText: '新建文字',
        createRect: '新建矩形',
        createCircle: '新建圆形',
        createLine: '新建直线',
        toggleRulerBar: '显示/隐藏标尺',
    },
    infiniteScroll: {
        loading: '玩命加载中...',
    },
    markupLayer: {
        tips: {
            firstClick: '点击开始标注',
            secondClick: '点击选择标注终点',
            thirdClick: '拖拽延长标注尺',
        },
    },
    textMarkSelector: {
        mark: '划重点',
        color: '颜色',
        size: '粗细',
        disabledByWritingMode: '竖排文字不支持划重点',
        disabledByTransform: '变形文字不支持划重点',
        disabledByTextMark: '划重点不支持竖排文字',
    },
    rulerBarPlugin: {
        switchStageUnit: '切换单位',
    },
    collapse: {
        messageError: {
            requestFailed: '请求素材失败',
            networkFailed: '您的网络发生异常，无法连接服务器',
            noNetwork: '网络已断开，请联网后重试',
            heicError: 'HEIC图片解析失败，建议您转换为其他图片格式上传',
            filetypeLimit: '暂时只支持JPG/JPEG/PNG/SVG/HEIC/GIF/WEBP格式图片',
            parsingFailed: '图片解析失败，建议您转换为其他图片格式上传',
            addFailed: '添加失败，请重试~',
        },
        tips: {
            deleteTitle: '删除提示',
            deleteDesc: '删除后将无法重新找回，请谨慎操作',
            okText: '确认删除',
            cancelText: '取消',
            deleteSuccess: '删除成功',
            addSuccess: '添加成功',
            addLoading: '正在添加...',
            selected: '已选择<></>条',
            recordDeleteDesc: '删除作图记录后将无法重新找回，请谨慎操作！',
            uploadDesc: '单击上传文件或拖放',
            uploadLimit: '仅支持20M以内的图片',
            uploadMaxLimit: '仅支持批量上传10张图片',
            noContent: '暂无内容',
            corner: '角标图片',
            uploadSuccess: '上传成功',
            noMore: '没有更多了~',
            uploading: '上传中',
            sizeLimit: '最大支持 ${0} x ${1} 的图片上传',
        },
        backgroundCollapse: {
            title: '背景颜色',
            detailTitle: '背景专题详情',
            recentUsed: '常用背景',
            all: '全部',
            messageError: {
                applyFailed: '背景应用失败',
            },
            kindTips: '温馨提示',
            applyTips: '图片已修改，是否应用此效果？',
            apply: '应用',
            cancel: '取消',
            messageInfo: '当前功能仅对原图生效，已自动隐藏无法操作的内容',
        },
        brushCollapse: {
            linePen: '直线笔',
            curvePen: '曲线笔',
            shape: '形状',
            choose: '选择画笔',
            tips: {
                moveToCanvas: '移动到画布中绘制',
                firstClick: '点击开始标注',
                secondClick: '点击选择标注终点',
                thirdClick: '拖拽延长标注尺',
            },
            all: '全部',
            custom: '自定义',
            markupPen: '标注笔',
            defineCurvePen: '自定义曲线笔',
            defineLinePen: '自定义直线笔',
            penStyle: '画笔样式',
            stroke: '描边',
            free: '限免',
        },
        materialCollapse: {
            newestTitle: '最新素材',
            detailTitle: '素材专题详情',
            commonUsed: '常用素材',
            recentUsed: '最近使用',
            recentSearch: '最近搜索',
            clearRecord: '清除记录',
            hotSearch: '大家都在搜',
            all: '全部',
            more: '更多',
            colors: '颜色',
            reload: '重新加载',
            feedback: '反馈',
            searchPlaceholder: '搜索素材',
            similarTitle: '相似素材',
            viewMore: '查看更多',
            similarRecommend: '相似推荐',
            loading: '加载中...',
            similarTag: '相似标签',
            tips: {
                noContent: '暂无内容',
                noContentDesc: '换个搜索词再试试${0}或反馈建议给我们',
                noNetwork: '网络有问题${0}重新加载试试吧',
            },
        },
        mineCollapse: {
            mySpace: '我的空间',
            myRecord: '作图记录',
            reUpload: '重新上传',
            addMaterial: '添加素材',
            noRecord: '暂无作图记录，快去开始你的设计吧',
            pptPage: 'PPT ${0}页',
            multiplePage: '多页面 ${0}页',
            all: '全部',
            delete: '删除',
            exit: '退出',
            image: '图片',
            text: '文字',
            group: '组合',
            folder: '文件夹',
            records: '作图记录',
            elements: '元素',
            myShare: '与我分享',
            add: '添加',
            noneFolder: '暂无文件夹',
            collapse: '收起',
            expand: '展开',
            viewAll: '查看全部',
            type: '类型',
            noFilesYet: '尚未添加任何文件',
            upload: '上传',
            poster: '海报设计',
            imageEditor: '图片编辑',
            upGradeTipsTitle: '作图记录全新升级！',
            upGradeTipsContent: '包含该账号下所有的海报模板和图片编辑作图记录了哦～ 从编辑图片到设计海报，无缝切换～',
            upGradeTipsOk: '我知道了',
            steps: {
                content: '滤镜与调色功能合并至此处',
                okText: '我知道了',
            },
            productShoot: 'AI商拍',
            aiLogo: 'AI Logo',
            aiShoeDesign: 'AI商品设计',
            aigcRecords: '生成记录',
        },
        templateCollapse: {
            recommend: '推荐模板',
            recentView: '最近浏览',
            homePage: '首页',
            backToList: '返回列表',
            applyAllPage: '应用所有页面',
            all: '全部',
            filter: '筛选',
            feedback: '反馈',
            search: {
                placeholder: '搜索模板',
                hotSearch: '大家都在搜',
                recentSearch: '最近搜索',
                searchKeyword: '搜索”${0}”',
                clear: '清空',
            },
            tips: {
                noContent: '暂无内容',
                noContentDesc: '换个搜索词再试试${0}或反馈建议给我们',
                applyWouldReplace: '使用模板后，当前内容将会被替换',
                replaceCurrentTemplate: '替换全部页面',
                replaceCurrentPage: '替换当前页面',
                replaceAllPage: '替换所有页面',
                replaceWouldApplyNewPage: '以哪种方式打开模板？',
                replaceWouldApplyAllPage: '替换模板后，内容将应用至所有页面',
                addToNewPage: '在当前画布添加页面',
                replace: '替换',
                cancel: '取消',
                openNewTab: '打开新页面',
            },
            aippt: {
                replaceTemplateTitle: '切换模板',
                applyTemplateBtn: '切换模板',
                selectTemplateTip: '请先选择模板',
            },
        },
        teamCollapse: {
            template: '模板',
            material: '素材',
            group: '标签组',
            ungrouped: '未分组',
            backToList: '返回列表',
            applyAllPage: '应用所有页面',
            addMaterial: '添加素材',
            reUpload: '重新上传',
            importTemplate: '导入模板',
            all: '全部',
            upload: '上传',
            exit: '退出',
            delete: '删除',
            tips: {
                uploading: '上传中',
                noText: '没有文本图层',
                noTag: '组内暂无标签哦~',
                noTemplate: '暂无模板，请上传您的模板',
                parsing: '解析中',
                parseFailed: '解析失败',
                parseSuccess: '解析成功',
                reUpload: '重新上传',
                continueUpload: '继续上传',
                uploadSuccess: '上传成功',
                chooseFile: '选择文件',
                dropFileOr: '将文件拖拽到此处上传，或',
                psdImportSpecification: 'PSD文件导入规范',
                applyWouldReplace: '使用模板后，当前内容将会被替换',
                replaceCurrentTemplate: '替换当前模板',
                replaceCurrentPage: '替换当前页面',
                replaceAllPage: '替换所有页面',
                replaceWouldApplyNewPage: '替换模板后，内容将应用至新页面',
                replaceWouldApplyAllPage: '替换模板后，内容将应用至所有页面',
                addToNewPage: '添加为新页面',
                replace: '替换',
                cancel: '取消',
            },
            messageError: {
                needUploadPsd: '请上传PSD文件！',
                psdSizeLimit: 'psd文件大于600M， 请检查是否太大',
                uploadFailed: '上传失败',
                uploadFailedReTry: '上传失败，请重试',
            },
        },
        navigationCollapse: {
            createPage: '新增',
            addPage: '添加页面',
            copyPage: '复制页面',
            deletePage: '删除页面',
            submit: '提交',
            ppt: {
                currentSubject: '当前PPT主题',
                prompt: 'prompt（指令）',
                placeHolder:
                    '建议参考当前PPT生成内容的上下文，填写一段具体描述，如：帮我再多补充关于【${0}】的PPT内容。',
                singlePptGenerate: '生成单页PPT',
                tips: {
                    generateSuccess: '生成成功',
                    singlePptGenerating: '正在生成单页PPT...',
                    pptReGenerating: '重新生成第${0}页...',
                    reGenerate: '重新生成',
                },
            },
            replaceComponentTitle: '替换样式',
            changeAnotherComponent: '换一批',
            componentReplacing: '切换组件中...',
            noComponentTip: '未匹配到相应组件',
            page: '页面',
        },
        textCollapse: {
            defaultText: '双击编辑文字',
            commonUsed: '常用素材',
            recentUsed: '最近使用',
            clickToAddText: '点击添加文本',
            title: '标题',
            subTitle: '副标题',
            contentText: '正文',
            more: '更多',
            all: '全部',
            messageError: {
                needNewest: '请使用最新的文字素材',
                fetchFailed: '获取素材失败',
            },
            search: {
                placeholder: '搜索文字',
            },
        },
        moreCollapse: {
            componentTool: {
                title: '组件',
                table: {
                    title: '表格',
                    desc: '提供丰富的表格样式，同时支持导入Excel文件。',
                    importExcel: '从Excel导入',
                    importExcelLimit: '仅支持导入${0}行*${1}列的Excel文件',
                    needSelected: '选择样式',
                    messageError: {
                        filetypeLimit: '仅支持.xlsx文件格式哦～',
                    },
                },
                qrCode: {
                    title: '二维码',
                    desc: '支持生成网址或公众号的二维码，同时提供丰富多变的样式。',
                    website: '网址',
                    official: '公众号',
                    needSelected: '选择样式',
                    createQrCode: '创建二维码',
                    uploadQrCode: '上传识别',
                    messageError: {
                        officialInputError: '请输入正确的公众号～',
                        recognitionFailed: '识别失败，请上传正确且清晰的二维码图片',
                    },
                    intlDesc: '支持根据网址生成二维码，并提供多种样式。',
                    intlTabTip: '请输入网址',
                },
            },
            imageModal: {
                title: '使用${0}前，请先选择一张图片~',
                desc: '选择海报模板中的图片 >',
                uploadImage: '上传图片',
                messageError: {
                    uploadFailed: '上传图片失败',
                },
            },
            imageTool: {
                title: '图片工具',
                generate: '生成',
                generating: '生成中',
                result: '生成结果：',
                reGenerate: '再次生成',
                imGenerate: '立即生成',
                image: '图片',
                apply: '应用',
                exit: '退出',
                messageError: {
                    failed: '生成失败',
                    aiFailed: 'AI${0}失败',
                    meidouReturned: '美豆已退回',
                },
                aiExpend: {
                    title: 'AI扩图',
                    desc: '在原图基础上对画面进行拓展，支持多种尺寸选择。',
                    originalRadio: '原比例',
                    sizeTitle: '扩展尺寸',
                    radioTitle: '扩展比例',
                    expend: '扩图',
                    toast: '扩图尺寸超出画布限制，暂时不能继续扩展啦～',
                },
                aiModify: {
                    title: '局部重绘',
                    desc: '输入文字，AI根据描述在指定区域内重新生成图片内容。',
                    internalTest: '内测',
                    promptDefault: '一只土拨鼠',
                    paintTitle: '涂抹选区：',
                    paintDescTitle: '请描述你的创意：',
                    tips: {
                        inputLimit: '最多可输入500个字',
                        inputPlaceholder: '请描述你要修改的画面内容。',
                        guide: '请先涂抹区域和填写创意',
                    },
                    modify: '重绘',
                    reset: '重置',
                },
                imageTranslation: {
                    title: '图片翻译',
                    desc: '翻译图片文本为各国语言并支持编辑，助力跨国营销。',
                    selectOriginalLanguage: '请选择原文语言：',
                    selectTranslation: '请选择译文语言：',
                    translate: '开始翻译',
                    translateAgain: '重新翻译',
                    original: '原文',
                    translation: '译文',
                    translationResult: '翻译结果',
                    noResult: '未在图片中检测到原文语言，请重新选择',
                    fail: '图片翻译失败，重新翻译试试吧～',
                    ok: '我知道了',
                    apply: '确认',
                    cancel: '取消',
                    confirmText: '进行其他操作后，将无法重新翻译图片，确认操作吗？',
                    sameSelect: '原文和译文语言一致，请重新选择',
                },
            },
            textTool: {
                title: '文字工具',
                generate: '生成',
                generating: '生成中',
                result: '生成结果：',
                reGenerate: '再次生成',
                imGenerate: '立即生成',
                aiText: {
                    title: 'AI花字',
                    desc: '更加富有创意的文字特效，非常适合海报标题使用。',
                    generating: 'AI花字生成中',
                    selectedTitle: '精选效果',
                    aiTextDesc: '每次生成1～${0}个字的效果最佳哦',
                    content: '内容',
                    font: '字体',
                    style: '样式',
                    textPreview: '文字预览：',
                    tips: {
                        inputPlaceholder: '请输入花字内容',
                        disclaimer: '免责声明',
                        disclaimerContent:
                            '使用本服务前您须理解，AI产出内容取决于人工智能对大数据的深度学习，不排除其中部分信息可能存在瑕疵、不合理或引发不快之处，故美图对通过算法生成内容的准确性、完整性和功能性等均不做任何保证，亦不承担包括侵犯第三人权利在内的任何法律责任；同时，因为AI设计服务依赖于您个人输入的文字信息生成相关内容，您需自行对输入信息及生成的内容进行理性选择；您须确保，依法使用本服务及其生成的AI作品，不侵犯任何第三方的版权、商标或其他合法权利，不得将生成的作品用于任何非法用途；如因您的不当使用行为导致任何第三方权益受损的，您将依法承担相应法律责任。',
                    },
                    messageError: {
                        needContent: '请输入花字内容',
                        needSelected: '请选择效果',
                        failed: '生成失败，请重新尝试',
                        inputLimit: '最多支持${0}个字哦～',
                    },
                },
            },
            migrateHint: '表格和二维码迁移到添加tab啦',
            batchTool: {
                title: '批量化',
                aiSizeExtend: {
                    title: 'AI尺寸延展',
                    desc: '以当前画布内容进行尺寸拓展，智能变换不同版式。',
                    currentCanvasSize: '当前画布尺寸',
                    unit: '单位',
                    selectDesc: '请选择需要延展的尺寸',
                    free: '限免',
                    width: '宽',
                    height: '高',
                    generateBtnText: '生成${0}个延展页面',
                },
                batchTemplate: {
                    title: '批量套模板',
                    desc: '输入文字/图片即可批量生成相同模板不同内容的海报。',
                    operateTip: '选中画布元素—点击匹配标签—选择标签',
                    changeDataBtnText: '修改数据',
                    generateBtnText: '生成${0}个页面',
                    exitBtnText: '退出批量套模板',
                    clearTableBtnText: '清空表格',
                    nextBtnText: '下一步',
                    cancelBtnText: '取消',
                    conformBtnText: '确认',
                    noInputLabelTip: '请选择标签和填写名称',
                    noMatchLabelTipText: '有标签项尚未匹配，继续生成将会丢失该信息，是否继续？',
                    clearAllDataTipText: '退出批量套模板后，填写的模板信息将会清空，确定退出吗？',
                    max80PageTipText: '超出页面数量80个限制，请调整页面数量后重试',
                    onlyUploadPngJpgTipText: '只能上传jpg或png格式图片',
                    maxFileSizeTipText: '仅支持20M以内的图片',
                    maxImageSizeTipText: '图片宽高不能超过8000像素',
                    inputLabelTypePlaceholder: '请输入标签名称',
                    labelTypeImageName: '图片',
                    labelTypeTextName: '文字',
                    labelTypeNoSelectName: '类型',
                    tableInputLine1: '1、请在首行下拉选择标签类型：文字、图片，并且输入标签名称。',
                    tableInputLine2: '2、选择标签后，请在下方填写对应标签的具体内容或者上传图片。',
                    clearTableTipText: '确定清除当前表格内容吗？',
                    changeLabelTypeClearDataTipText: '切换类型后，已填写信息将会清空，确认切换吗？',
                    noMatchLayerText: '未匹配',
                    isGeneratingText: '生成中...',
                    tipTitle1: '手动输入：',
                    tipTitle2: '上传文件：',
                    tip1: '1、请在标签行，下拉选择标签类型：文字、图片，井且输入标签名称。',
                    tip2: '2、输入标签后，请在页面行填写对应标签的具体内容或上传图片。',
                    tip3: '1、 支持xlsx，xls格式的文件。',
                    tip4: '2、首行将柀识别成标签信息，首行以下的表格内容将柀识别成页面信息。',
                    tip5: '3、上传文件不支持插入图片。',
                    uploadBtn: '上传文件',
                    uploadTip: '上传表格后，将会覆盖已填写的信息，是否继续',
                    uploadFailTip: '请上传正确的文件！',
                },
            },
        },
        shortcutCollapse: {
            picture: {
                title: '图片',
                localUpload: '本地上传',
                myPicture: '我的图片',
                more: '更多',
            },
            text: {
                menuTitle: '文字',
                title: '标题',
                subTitle: '副标题',
                text: '正文',
                deformedLetters: '变形文字',
                specialEffectText: '特效文字',
                more: '更多',
            },
            Brush: {
                title: '画图',
                more: '更多',
            },
        },
        adjustCollapse: {
            cropTitle: '裁剪/旋转/尺寸',
            sizeAdjustment: '尺寸调整',
            proportionalCrop: '比例裁剪',
            shapeMask: '形状蒙版',
            okText: '确定',
            cancelText: '取消',
            intelligentColor: '一键换色',
            sourceColor: '源颜色',
            sourceColorDesc: '选择图片中的一种颜色',
            colorTolerance: '颜色容差',
            targetColor: '目标颜色',
            targetColorDesc: '需要替换成的颜色',
            eraser: '擦除',
            eraserDesc: '擦除或涂抹目标颜色区域',
            clear: '清空',
            recommendedEffect: '推荐效果',
            resetEffect: '重置效果',
            manualColor: '手动调色',
            hue: '色相',
            saturation: '饱和度',
            brightness: '明度',
            clearEffect: '清除效果',
            noEffectOnEmptyCanvas: '当前功能对创建的空画布不生效哦~',
            addCustomSize: '添加自定义尺寸',
            apply: '应用',
            custom: '自定义',
            lockedScale: '锁定比例',
            unLockedScale: '未锁定比例',
            leftRotate: '左旋转90°',
            rightRotate: '右旋转90°',
            horizontalFlip: '水平翻转',
            verticalFlip: '垂直翻转',
            reset: '重置',
            freeCutting: '自由裁剪',
            px: '像素',
            cm: '厘米',
            cropList: {
                square: '1:1 正方形',
                verticalCamera: '2:3 单反相机(竖)',
                horizontalCamera: '3:2 单反相机(横)',
                standardVerticalScreen: '3:4 标准屏幕(竖)',
                standardHorizontalScreen: '4:3 标准屏幕(横)',
                verticalVideo: '9:16 视频竖屏',
                horizontalVideo: '16:9 视频横屏',
                verticalFullScreen: '9:18 全面屏(竖)',
                horizontalFullScreen: '18:9 全面屏(横)',
                widescreenPhotoAlbum: '5:3 宽屏相册',
            },
            losslessResizing: '无损改尺寸',
            losslessResizingDesc: '提升画面质量，保证清晰度',
        },
        filterCollapse: {
            confirmTitle: '温馨提示',
            confirmContent: '图片已修改,是否应用此效果?',
        },
        watermarkCollapse: {
            addSuccessText: '添加成功',
            onLineError: '网络已断开，请联网后重试',
            all: '全部',
            confirmContent: '目前只允许设置单个水印内容，点击后您当前设置的水印将被替换，是否替换当前水印？',
            confirmNoMind: '不再提示',
            confirmTitle: '提示',
            confirmOk: '确认',
            confirmCancel: '取消',
            materialDetail: '素材专题详情',
            recommendMaterial: '推荐素材',
            recentlyMaterial: '最近使用',
            uploadWatermark: '上传水印',
            limitImageSize: '仅支持20M以内的图片',
        },
        brandLibCollapse: {
            brandTabTitle: '品牌规范',
            templateTabTitle: '模板库',
            textStyleTitle: '文字样式',
            logoTitle: 'logo',
            more: '全部',
            emptyText: '暂无内容',
        },
        mogCollapse: {
            preset: '调色预设',
            reset: '重置效果',
            none: '无',
        },
    },
    panel: {
        markupPanel: {
            thickness: '粗细',
            brush: '画图',
            label: '尺寸文案',
            type: '类型',
            num: '数值',
            custom: '自定义文案',
            unit: '单位',
            unitPlaceholder: '选择单位',
            unitTip: '单位多选时，以最小单位进行换算和展示。如：100mm/10cm/3.94inch',
            text: '文案',
            textPlaceholder: '输入尺寸文案',
            position: '位置',
            up: '线条上方',
            center: '线条中间',
            down: '线条下方',
            rotate: '角度',
            fontFamily: '字体',
            fontSize: '字号',
            style: '样式',
            background: '背景色',
            stroke: '描边',
            color: '颜色',
            endpoint: '端点',
            line: '显示延长线',
            opacity: '透明度',
            segment: '指引文案',
            lineStyle: '线条样式',
            angle: '角度文案',
            angleArea: '角度区域',
        },
        backgroundPanel: {
            canvas: '画布',
            canvasSize: '画布尺寸',
            adjustSize: '调整尺寸',
            horizontalFlip: '水平翻转',
            verticalFlip: '垂直翻转',
            canvasBackground: '画布背景',
            restoreBackground: '恢复原始背景',
            width: '宽',
            height: '高',
            replace: '替换',
            crop: '裁剪',
            color: '颜色',
            image: '图片',
            uploadImage: '上传图片',
            cropLimit: '当前背景为平铺背景，不支持裁剪功能',
            splitBackground: '分离背景图',
            opacity: '透明度',
            clickOrDropToUpload: '点击上传图片${0}或拖拽文件到框内上传',
            customSize: '自定义尺寸',
            originalSize: '原尺寸',
            saveSize: '保存尺寸',
            presetSize: '预设尺寸',
            unit: '单位:',
            lockRatio: '锁定宽高比',
            customRatio: '自定义比例',
            smartLayout: '智能排版',
            tips: {
                splitSuccess: '背景已分离成图片',
                deleteConfirm: '确定删除当前尺寸吗？',
                okText: '确定',
                cancelText: '取消',
                deleteSuccess: '删除当前尺寸成功',
                saveSizeSuccess: '自定义尺寸保存成功',
                adjustSizeWouldChangeLayout: '修改后，当前模板排版会产生变化。',
                addToMySize: '添加到我的尺寸',
                add: '添加',
                inputSizeName: '输入尺寸名称',
            },
            messageError: {
                uploadNumLimit: '仅支持上传1张图片',
                canvasSizeLimit: '画布尺寸需在限制范围内',
                saveSizeFailed: '自定义尺寸保存失败',
                autoAdjustedToLimit: '画布尺寸自动调整为限制范围',
            },
            background: '背景',
            imageSize: '图片尺寸',
            backgroundSize: '背景尺寸',
            customSizeTitle: '我的尺寸',
            addSize: '添加',
            recommendSizeTitle: '推荐尺寸',
            currentCanvasSize: '当前画布尺寸',
            aiSizeExtend: 'AI尺寸延展',
            free: '限免',
            smartLayoutTip: '调整大小时保持画布内的元素布局不变',
            recommendColor: '推荐颜色',
            currentBgColor: '当前背景色',
            selectFromBackground: '从背景库选择',
            dynamicPanel: {
                title: '动态背景',
                hiddenLabel: '是否显示',
                open: '开',
                close: '关',
            },
            reEdit: '返回商品编辑',
            edit: '编辑',
            before: '原图',
            after: '结果图',
        },
        brushPanel: {
            brush: '画图',
            brushPen: '画笔',
            shape: '形状',
            style: '样式',
            stroke: '描边',
            color: '颜色',
            endpoint: '端点',
            opacity: '透明度',
            radius: '圆角',
            thickness: '粗细',
        },
        groupPanel: {
            multiSelect: '多选',
            group: '组合',
            makeGroup: '组合',
            breakGroup: '取消组合',
            mergeLayer: '合并图层',
            tips: {
                breakGroupVipLimit: '付费素材不支持解组使用',
                mergeConfirm: '合并后，所选图层将变为一张图片，确认合并吗?',
                okText: '合并',
                cancelText: '取消',
            },
        },
        imagePanel: {
            image: '图片',
            aiImage: 'AI图片',
            imageSetting: '图片设置',
            imageAdjust: '调色',
            baseImageAdjust: '基础调色',
            advancedImageAdjust: '高级调色',
            adjustLight: '光效',
            adjustColor: '色彩',
            adjustParticulars: '细节',
            adjustPosterize: '色调分离',
            adjustHsl: 'HSL',
            effect: '特效',
            imageEliminatePen: '消除笔',
            cancel: '取消',
            complete: '完成',
            undo: '撤销',
            redo: '重做',
            reset: '重置',
            delete: '删除',
            exit: '退出',
            imageFilter: '滤镜',
            imageMask: '蒙版',
            aiGenerateImageTitle: 'AI图片画面描述',
            aiGenerateImageDesc: '您可以根据需求调整当前素材${0}的画面描述，风格，色彩效果',
            inputPlaceholder: '请输入',
            generatingImage: '我们正努力把您脑海中的设想呈现出来，请耐心等待一会～',
            reGenerate: '重新生成',
            cutoutMemberLimit: '抠图张数不足，开通会员送张数',
            cutoutRechargeLimit: '抠图张数不足，请先充值',
            monthMemberPresent: '月会员送 50张/月',
            seasonMemberPresent: '季会员送 250张/季',
            yearMemberPresent: '年会员送 1200张/年',
            activateMember: '立即开通',
            discountedPrice: '优惠低至¥0.16元/张',
            permanentlyValid: '张数永久有效',
            rechargeNow: '立即充值',
            replaceImage: '替换图片',
            imageCrop: '裁剪',
            imageCutout: '抠图',
            opacity: '透明度',
            pasterDesc: '使用截图工具后${0}在此粘贴图片',
            import: '导入',
            mySpace: '我的空间',
            teamMaterial: '团队素材',
            selectedPhoto: '精选照片',
            importClipboard: '本地上传',
            addImage: '添加图片',
            unnamed: '未命名',
            format: '格式：',
            size: '尺寸：',
            tips: {
                uploadSuccess: '上传成功',
                uploadLimit: '仅支持20M以内的图片',
                deleteTitle: '删除提示',
                deleteDesc: '删除后将无法重新找回，请谨慎操作',
                okText: '确认删除',
                cancelText: '取消',
                deleteSuccess: '删除成功',
                selected: '已选择 <></> 条',
                noMaterial: '暂无内容，点击添加素材上传',
                matting: '抠图中...',
                bathAdd: '批量添加',
            },
            messageError: {
                generateFailed: '生成图片失败',
                networkError: '您的网络发生异常，无法连接服务器',
                importFailed: '导入失败',
                filetypeLimit: '仅支持jpg,png,heic,svg图片',
                uploadFailed: '上传失败',
            },
            share: {
                uploadImage: '上传图片',
                uploadTip: '点击/拖拽/粘贴图片至此处',
                imageTip: '支持上传20M以内JPG、JPEG、PNG，最多支持${0}张',
                bathAdd: '批量添加',
                imageTipText: '支持上传20M以内JPG、JPEG、PNG',
                uploadCountTip: '最多支持添加${0}张图片哦～',
            },
            removeBgTip: '点击这里去除背景哦',
        },
        qrCodePanel: {
            qrCode: '二维码',
            style: '样式',
            color: '颜色',
            opacity: '透明度',
            backgroundColor: '背景色',
            qrCodeColor: '二维码颜色',
            website: '网址',
            official: '公众号',
            websitePlaceholder: '在此输入网址',
            officialPlaceholder: '在此输入公众号',
            uploadIdentify: '上传识别',
            updateQrCode: '更新二维码',
            selectStyle: '请选择样式',
            messageError: {
                websiteInputError: '请输入正确的网址～',
                officialInputError: '请输入正确的公众号～',
                recognitionFailed: '识别失败，请上传正确且清晰的二维码图片',
            },
        },
        tablePanel: {
            table: '表格',
            opacity: '透明度',
            textStyle: '文字样式',
        },
        textPanel: {
            text: '文字',
            style: '风格',
            normal: '常规',
            textEffect: '文字特效',
            textEffectBase: '基础',
            textEffectArt: '花字',
            textTransform: '文字变形',
            advanceSetting: '高级设置',
            textStyle: '文字样式',
            transform: '变形',
            messageError: {
                generateFailed: '生成文字失败',
            },
            textMark: '划重点',
        },
        vectorPanel: {
            vectorShape: '图形',
            style: '样式',
            stroke: '描边',
            color: '颜色',
            opacity: '透明度',
            radius: '圆角',
            textInfo: {
                vPadding: '上下边距',
                hPadding: '左右边距',
            },
            thickness: '粗细',
            blur: '模糊',
            vectorEffect: '图形特效',
            effect: {
                shadow: '阴影',
                reflection: '倒影',
                stroke: '描边',
                distance: '距离',
                size: '大小',
            },
            modalTitle: '设置',
        },
        watermarkPanel: {
            openTile: '开启平铺',
            closeTile: '关闭平铺',
            watermarkText: '水印文案',
            placeholderText: '请输入文本',
            watermarkSize: '水印大小',
            watermarkSpace: '水印间距',
            watermarkCross: '水印交错',
            watermarkRotate: '水印旋转',
            requireLogin: '请先登录账号后上传图片',
            limitImageSize: '仅支持20M以内的图片',
            replace: '替换',
            watermark: '水印',
            settingStyle: '样式设置',
            onlySupport: '仅支持在水印板块下对平铺样式进行设置',
            opacity: '不透明度',
            fontColor: '字体颜色',
            tileDisplay: '平铺展示',
        },
        mediaPanel: {
            media: '动态素材',
            opacity: '透明度',
            posterPlaceholder: '在此输入视频封面地址',
            videoUrlPlaceholder: '在此输入视频地址',
            updatePoster: '更新封面',
            updateVideoUrl: '更新视频地址',
            posterInputError: '请输入正确的视频封面地址',
            videoUrlInputError: '请输入正确的视频地址',
        },
    },
    productRetouching: {
        apply: '一键精修',
        applying: '精修中...',
        productRetouching: '商品精修',
        common: '通用商品',
        hardware: '五金制品',
        cosmetic: '化妆品',
        leatherProducts: '皮制品',
        contrast: '对比',
        matting: '抠图精修',
        fullImage: '保留背景',
        select: '选择商品',
    },
    plugin: {
        hierarchy: {
            layer: '图层',
            title: '图层管理',
            back: '返回上层',
            groupLayer: '组',
            mainLayer: '主图',
            backgroundLayer: '背景',
            duplicate: '创建副本',
            delete: '删除',
            imageLayer: '图片',
            vectorLayer: '图形',
            tableLayer: '表格',
            chartLayer: '图表',
            qrcodeLayer: '二维码',
            watermarkLayer: '水印',
            draw: '画图',
            reupload: '重新上传',
            mattingOptimize: '抠图优化',
            empty: '暂无图层',
        },
    },
    stage: {
        defaultText: '双击修改文字',
        viewImageInfo: '双击替换图片',
    },
    baseToolbar: {
        size: '尺寸',
        width: '宽',
        height: '高',
        lockRatio: '锁定宽高比例',
        customRatio: '自定义比例',
        position: '位置',
        compose: '排版',
        angle: '角度',
        rotate90: '旋转90°',
        flipHorizontal: '水平翻转',
        flipVertical: '垂直翻转',
        alignLeft: '左对齐',
        alignCenter: '水平居中',
        alignRight: '右对齐',
        alignTop: '顶部对齐',
        alignVertical: '垂直居中',
        alignBottom: '底部对齐',
        vertical: '垂直分布',
        horizontal: '水平分布',
        dimension: 'Dimensions',
        adjust: 'Adjust',
        opacity: 'Opacity',
        sizeRange: 'Size',
        perspective: 'Perspective',
        deformation: 'Deformation',
        leftRotate: 'Left rotate 90°',
        rightRotate: 'Right rotate 90°',
    },
    headerToolbar: {
        replace: '替换',
        title: {
            group: '组合',
            img: '图片',
            text: '文字',
            vector: '图形/文字',
            table: '表格',
            qrCode: '二维码',
            brush: '画图',
            waterMark: '水印',
            media: '动态素材',
            chart: '图表',
            puzzle: '拼图',
        },
        copyBtn: {
            copyText: '复制图层',
        },
        deleteBtn: {
            delText: '删除图层',
        },
        lockBtn: {
            lock: '锁定图层',
            unLock: '解锁图层',
        },
        sortBtn: {
            index: '图层顺序',
            bottom: '图层置底',
            top: '图层置顶',
            order: '图层排序',
        },
        textBrushBtn: {
            copyStyle: '复制样式',
        },
    },
    chartLayer: {
        panel: {
            editData: '编辑图表数据',
            clearData: '清空数据',
            typeSection: {
                name: '类型',
                typeMap: {
                    'bar-basic': '柱状图',
                    'bar-stacked': '堆叠柱状图',
                    'bar-horizontal-basic': '条形图',
                    'bar-horizontal-stacked': '堆叠条形图',
                    'line-basic': '折线图',
                    'pie-basic': '饼图',
                    'pie-doughnut': '环形图',
                },
            },
            colorSection: {
                name: '颜色',
            },
            showSection: {
                name: '选项',
                options: {
                    data: '数据',
                    label: '标签',
                    allAxis: '横坐标和纵坐标',
                    axisAndTag: '坐标与标签',
                    xAxis: '横坐标',
                    yAxis: '纵坐标',
                    legend: '图例',
                    top: '上方',
                    bottom: '下方',
                    left: '左侧',
                    right: '右侧',
                    gridLine: '网格线',
                },
            },
            radius: '圆角',
            addOneRowOnAbove: '在上方添加 1 行',
            addOneRowOnBelow: '在下方添加 1 行',
            addOneColOnAbove: '在前方添加 1 列',
            addOneColOnBelow: '在后方添加 1 列',
            delete: '删除',
        },
        data: {
            series: '系列',
            item: '项目',
        },
        emptyChart: '没有要显示的数据',
    },
    qualityPanel: {
        apply: '变清晰',
        general: '通用',
        qualitySceneTitle: '场景',
        qualitySceneSubTitle: '针对特定场景优化，尽显专业级清晰度。',
        hd: '高清',
        hdu: '超清',
        hdSubTxt: '原图尺寸',
        sd: '标清',
        aiHud: 'AI超清',
        aiHudSubTxt: '智能补充画面细节，画质更清晰。',
        product: '商品',
        text: '文本',
        portrait: '人像',
    },
};
